import { z } from 'zod';

export const validationSendDocumentsModal = z.object({
  contact_person: z.string(),
  address: z.string(),
  contact_phone: z.string(),
});

export type sendDocsParams = z.infer<typeof validationSendDocumentsModal>;